// import echarts from "echarts";
import * as echarts from "echarts";

export function loadLineChart(
  myChart,
  data,
  ValveData,
  name,
  fontSizes,
  czUnit = "元/人"
) {
  let xAxisData = data.map(v => v.year);
  let yqData = data.map(v => v.yqrjsr);
  let qxData = data.map(v => v.qxrjsr);

  let qyData = [];
  if (name) {
    qyData = data.map(v => v.qyrjsr);
  }

  myChart.setOption(
    {
      color: ["#00A7FD", "#B683DD", "#25C2B9"],
      grid: {
        top: 35,
        right: 40,
        left: 10,
        bottom: 5,
        containLabel: true
      },
      legend: {
        show: true,
        x: "right",
        y: 0,
        textStyle: {
          color: "#fff",
          fontSize: fontSizes
        },
        itemWidth: 16,
        itemHeight: fontSizes
      },
      tooltip: {
        trigger: "axis",
        formatter: function(params) {
          var showHtm = "";
          if (params instanceof Array) {
            showHtm = params[0].name + "<br/>";
            for (var i = 0; i < params.length; i++) {
              showHtm +=
                params[i].marker +
                params[i].seriesName +
                ":" +
                params[i].value +
                czUnit +
                "<br/>";
            }
          }
          return showHtm;
        }
      },
      xAxis: [
        {
          type: "category",
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          },
          data: xAxisData
        }
      ],
      yAxis: [
        {
          type: "value",
          name: "单位：" + czUnit,
          scale: true,
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: fontSizes
            }
          },
          nameTextStyle: {
            verticalAlign: "middle",
            color: "#fff",
            fontSize: fontSizes
          },
          splitLine: {
            lineStyle: {
              color: "rgba(0, 144, 255,0.3)"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
              fontSize: fontSizes
            }
          },
          axisTick: {
            show: false
          }
        }
      ],
      series: [
        {
          name,
          type: "line",
          smooth: true,
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgba(0,167,253, 0.3)"
                  },
                  {
                    offset: 1,
                    color: "rgba(0,167,253,0.1)"
                  }
                ],
                false
              ),
              shadowColor: "rgba(222,168,93,0.1)",
              shadowBlur: 10
            }
          },
          markLine: {
            silent: true,
            lineStyle: {
              color: "#fff"
            },
            data: [
              {
                yAxis: ValveData
              }
            ]
          },
          data: qyData
        },
        {
          name: "产业园",
          type: "line",
          smooth: true,
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgba(236, 123, 84, 0.3)"
                  },
                  {
                    offset: 1,
                    color: "rgba(236, 123, 84,0.1)"
                  }
                ],
                false
              ),
              shadowColor: "rgba(236, 123, 84,0.1)",
              shadowBlur: 10
            }
          },
          markLine: {
            silent: true,
            lineStyle: {
              color: "#fff"
            },
            data: [
              {
                yAxis: ValveData
              }
            ]
          },
          data: yqData
        },
        {
          name: "全区",
          type: "line",
          smooth: true,
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgba(40, 195, 185, 0.3)"
                  },
                  {
                    offset: 1,
                    color: "rgba(40, 195, 185,0.1)"
                  }
                ],
                false
              ),
              shadowColor: "rgba(40, 195, 185,0.1)",
              shadowBlur: 10
            }
          },
          data: qxData
        }
      ]
    },
    true
  );
}
